'use client';

import { c as _c } from "react/compiler-runtime";
import { domAnimation, LazyMotion, m, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';
import { MOTION_ENTRANCE } from '@/lib/ui/easing';

// ---------------------------------------------------------------------------
// Animated tab content — fades in and slides up on mount. Each social-page
// tab wraps its body in <TabContent> so switching tabs (which unmounts the
// previous tab and mounts the new one in Radix Tabs) plays a fresh entrance.
//
// Podium cards render in `SocialClient` above the tab switcher — this
// wrapper only animates the rank card + table block.
//
// Honors reduced motion: when the user prefers reduced motion the animation
// is skipped (opacity 1, no offset, no transition).
// ---------------------------------------------------------------------------

interface TabContentProps {
  children: ReactNode;
}
const TAB_ENTER_OFFSET_PX = 8;
export function TabContent(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const prefersReducedMotion = useReducedMotion();
  const reduceMotion = prefersReducedMotion === true;
  let t1;
  if ($[0] !== reduceMotion) {
    t1 = reduceMotion ? false : {
      opacity: 0,
      y: TAB_ENTER_OFFSET_PX
    };
    $[0] = reduceMotion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1,
      y: 0
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== reduceMotion) {
    t3 = reduceMotion ? {
      duration: 0
    } : MOTION_ENTRANCE;
    $[3] = reduceMotion;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t3) {
    t4 = <LazyMotion features={domAnimation}><m.div className="flex flex-col gap-6" initial={t1} animate={t2} transition={t3}>{children}</m.div></LazyMotion>;
    $[5] = children;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}